import { Component, EventEmitter, OnInit, Output } from '@angular/core';
/**
  Componente que muestra un banner con información sobre un vuelo afectado por irregularidades operativas (IROPS).
  Este componente permite al usuario continuar con el proceso o cambiar de vuelo, emitiendo eventos correspondientes
  cuando se realizan estas acciones.
**/
@Component({
    selector: 'banner-irops-flight-info',
    templateUrl: './banner-irops-flight-info.component.html',
    styleUrls: ['./banner-irops-flight-info.component.scss'],
    standalone: false
})
export class BannerIropsFlightInfoComponent implements OnInit {

   /**
    Evento que se emite cuando el usuario hace clic en el botón de "Cambiar".
    @type {EventEmitter<any>}
  **/
    @Output() private clickChange: EventEmitter<any>;

    /**
      Evento que se emite cuando el usuario hace clic en el botón de "Continuar".
      @type {EventEmitter<any>}
    **/
    @Output() private clickContinue: EventEmitter<any>;

  constructor() {
    this.clickContinue = new EventEmitter();
    this.clickChange = new EventEmitter();
  }

  ngOnInit() {
  }

  onContinue(): void {
    this.clickContinue.emit();
  }

  onChange(): void {
    this.clickChange.emit();
  }

}